<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />

    <div class="animation-sheet">
      <h1 class="title mb-5">
        <span v-html="currentFiche.titre"></span>
        <br aria-hidden="true" />
        <small v-if="ficheId != undefined"><em>Fiches pour animer une communauté d’apprentissage professionnelle (CAP)</em></small>
        <small v-if="allerPlusLoinId != undefined"><em>Pour aller plus loin</em></small>
      </h1>

      <!-- Section -->
      <div class="section-container" v-for="(section, sectionIndex) in currentFiche.sections" :key="'section' + sectionIndex">
        <!-- <span class="section-num" aria-hidden="true">{{ sectionIndex + 1 }}</span> -->
        <div class="section-area">
          <!-- .titre -->
          <h2 v-html="section.titre"></h2>
          <div class="row">
            <div :class="{ 'col-12 col-md-8 col-lg-9': section.imageSrc, 'col-12': !section.imageSrc }">
              <!-- .bullets -->
              <ul v-if="section.bullets">
                <li v-for="(bullet, bulletIndex) in section.bullets" :key="bulletIndex" v-html="bullet"></li>
              </ul>

              <!-- .linkBullets -->
              <ul v-if="section.linkBullets">
                <li v-for="(bullet, bulletIndex) in section.linkBullets" :key="bulletIndex"><a :href="bullet.link" target="_blank" v-html="bullet.text"> </a></li>
              </ul>

              <!-- .html -->
              <div v-if="section.html" v-html="section.html"></div>

              <!-- .video -->
              <div class="row video-section" v-if="section.video">
                <div class="col-12 mx-auto">
                  <p v-html="section.video.titre"></p>
                  <!-- <div class="embed-responsive embed-responsive-16by9"> -->
                  <VideoPlayer ref="videoPlayerRef" class="centered-element video-element" :youtube="section.video.isYoutubeVideo" :url="section.video.videoUrl" :poster="section.video.poster" :transcription="section.video.transcription"></VideoPlayer>
                  <!-- </div> -->
                </div>
              </div>
              <!-- .attachement -->
              <div class="row attachement" v-if="section.attachement">
                <div class="col-12 col-md-10 mx-auto">
                  <h3>L'attachement</h3>
                  <img class="img-fluid corner-cutted" :src="section.attachement.imageSrc" :alt="section.attachement.imageAlt" />
                </div>
              </div>

              <!-- .defis -->
              <div class="defi-wrapper">
                <div class="row defi-box" v-for="(defi, defiIndex) in section.defis" :key="defiIndex">
                  <div class="d-none d-md-block col-md-3 col-lg-2">
                    <!-- .imageSrc .imageAlt -->
                    <img :src="defi.imageSrc" class="img-fluid corner-cutted" :alt="defi.imageAlt" />
                  </div>
                  <div class="col-md-9 col-lg-10">
                    <h3>
                      <!-- .titre -->
                      <span>Défi {{ defiIndex + 1 }}&nbsp;: </span><span v-html="defi.titre"></span>
                    </h3>
                    <p class="mb-2">
                      <em>Milieu&nbsp;: <span v-html="defi.milieu"></span></em>
                    </p>
                    <!-- .html -->
                    <div v-if="defi.html" v-html="defi.html"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- .imageSrc .imageAlt -->
            <div class="d-none d-md-block col-md-4 col-lg-3 mx-auto" v-if="section.imageSrc">
              <img :src="section.imageSrc" class="img-fluid corner-cutted" :alt="section.imageAlt" />
            </div>
          </div>
        </div>
      </div>

      <!-- Section info supp -->
      <div class="section-container">
        <!-- <span class="section-num" aria-hidden="true">{{ currentFiche.sections.length + 1 }}</span> -->

        <div class="section-area">
          <!-- .titre -->
          <h2>Informations supplémentaires</h2>
          <!-- DESKTOP VIEW (MD AND UP) -->
          <table class="table infoSuppTable d-none d-md-block">
            <thead>
              <tr>
                <th scope="col"><span v-html="currentFiche.infoSupp[0].titre"></span></th>
                <th scope="col"><span v-html="currentFiche.infoSupp[1].titre"></span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <!-- .bullets -->
                  <ul v-if="currentFiche.infoSupp[0].bullets">
                    <li v-for="(bullet, bulletIndex) in currentFiche.infoSupp[0].bullets" :key="bulletIndex" v-html="bullet"></li>
                  </ul>
                  <!-- .linkBullets -->
                  <ul v-if="currentFiche.infoSupp[0].linkBullets">
                    <li v-for="(bullet, bulletIndex) in currentFiche.infoSupp[0].linkBullets" :key="bulletIndex">
                      <a :href="bullet.link" target="_blank" :aria-label="bullet.text + ' (lien externe)'"><span v-html="bullet.text"></span>&nbsp;<font-awesome-icon title="Lien externe" icon="external-link-alt"/></a>
                    </li>
                  </ul>
                </td>
                <td>
                  <!-- .bullets -->
                  <ul v-if="currentFiche.infoSupp[1].bullets">
                    <li v-for="(bullet, bulletIndex) in currentFiche.infoSupp[1].bullets" :key="bulletIndex" v-html="bullet"></li>
                  </ul>
                  <!-- .linkBullets -->
                  <ul v-if="currentFiche.infoSupp[1].linkBullets">
                    <li v-for="linkBullet in currentFiche.infoSupp[1].linkBullets" :key="linkBullet.text">
                      <router-link :to="getPageLink(linkBullet.link)">{{ linkBullet.text }}</router-link>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- MOBILE VIEW (XS AND SM) -->
          <div class="infoSuppTable d-md-none">
            <h3 v-html="currentFiche.infoSupp[0].titre"></h3>
            <!-- .bullets -->
            <ul v-if="currentFiche.infoSupp[0].bullets">
              <li v-for="(bullet, bulletIndex) in currentFiche.infoSupp[0].bullets" :key="bulletIndex" v-html="bullet"></li>
            </ul>
            <!-- .linkBullets -->
            <ul v-if="currentFiche.infoSupp[0].linkBullets">
              <li v-for="(bullet, bulletIndex) in currentFiche.infoSupp[0].linkBullets" :key="bulletIndex">
                <a :href="bullet.link" target="_blank" :aria-label="bullet.text + ' (lien externe)'"><span v-html="bullet.text"></span>&nbsp;<font-awesome-icon title="Lien externe" icon="external-link-alt"/></a>
              </li>
            </ul>
            <h3 v-html="currentFiche.infoSupp[1].titre"></h3>
            <!-- .bullets -->
            <ul v-if="currentFiche.infoSupp[1].bullets">
              <li v-for="(bullet, bulletIndex) in currentFiche.infoSupp[1].bullets" :key="bulletIndex" v-html="bullet"></li>
            </ul>
            <!-- .linkBullets -->
            <ul v-if="currentFiche.infoSupp[1].linkBullets">
              <li v-for="linkBullet in currentFiche.infoSupp[1].linkBullets" :key="linkBullet.text">
                <router-link :to="getPageLink(linkBullet.link)">{{ linkBullet.text }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
import VideoPlayer from "../components/VideoPlayer.vue";
export default {
  components: {
    ProgressBars,
    VideoPlayer,
  },
  props: {
    allerPlusLoinId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      currentFiche: [],
      // Exemple de fiches
      // fichesEG: [
      //   {
      //     id: "",
      //     sujetCible: "",
      //     titre: "",
      //     sections: [
      //       {
      //         titre: "",
      //         bullets: ["", ""],
      //         linkBullets: [
      //           {
      //             text: "",
      //             link: "",
      //           },
      //           // ...
      //         ],
      //         html: ``,
      //         defis: [
      //           {
      //             titre: "",
      //             milieu: "",
      //             html: ``,
      //             // imageSrc: require("@/assets/fiches/cap1/AdobeStock_.jpeg"),
      //             imageAlt: "",
      //           },
      //           // ...
      //         ],
      //         // imageSrc: require("@/assets/fiches/cap1/"),
      //         imageAlt: "",
      //       },
      //       // ...
      //     ],
      //     infoSupp: [
      //       {
      //         titre: "",
      //         bullets: ["", ""],
      //         linkBullets: [
      //           {
      //             text: "",
      //             link: "",
      //           },
      //           // ...
      //         ],
      //         html: ``,
      //         // imageSrc: require("@/assets/fiches/cap1/"),
      //         imageAlt: "",
      //       },
      //       // ...
      //     ],
      //   },
      //   // ...
      // ],

      allerPlusLoin: [
        // allerPlusLoin 1
        {
          sujetCible: "",
          titre: "Les relations authentiques",
          sections: [
            {
              titre: "Résumé des concepts du sujet&nbsp;: définition/mise en contexte",
              html: `<p>Les relations authentiques sont à la base de l’approche en petite enfance. Sans elles, il ne peut pas y avoir d’apprentissages significatifs.</p>`,
              imageSrc: require("@/assets/fiches/apl1/AdobeStock_28006614.jpeg"),
              imageAlt: "",
            },
            {
              titre: "Questions de réflexion en lien avec le sujet ciblé",
              html: `<p>Nous te proposons de relever un défi. Selon toi, quel sera l’impact de ce défi sur le développement socioémotionnel des enfants? Documente le processus afin de vérifier tes hypothèses.</p>`,
              imageSrc: require("@/assets/fiches/apl1/AdobeStock_255036539.jpeg"),
              imageAlt: "",
            },
            {
              titre: "Défis en lien avec le sujet ciblé",
              defis: [
                {
                  titre: "Les mots que l’on choisit...",
                  // milieu: "centre éducatif",
                  milieu: this.LG("SA_nameAreaSection2"),
                  html: `<p>Aujourd’hui, fais un effort pour ne pas dire non et prendre conscience de la façon dont tu t’adresses aux enfants.</p>`,
                  imageSrc: require("@/assets/fiches/apl1/AdobeStock_186417756.jpeg"),
                  imageAlt: "",
                },
                {
                  titre: "L’unicité de chaque enfant",
                  // milieu: "familial",
                  milieu: this.LG("SA_nameAreaSection4"),
                  html: `<p>Aujourd’hui, prends une photo de chaque enfant et partage-la avec sa famille en mettant en valeur une force ou une compétence de l’enfant.</p>`,
                  imageSrc: require("@/assets/fiches/apl1/AdobeStock_213804967.jpeg"),
                  imageAlt: "",
                },
                {
                  titre: "Apprenons à nous connaître...",
                  // milieu: "école",
                  milieu: this.LG("SA_nameAreaSection3"),
                  html: `<p>Prends le temps de discuter avec chaque enfant afin de découvrir un nouveau champ d’intérêt que tu ne connaissais pas (pense à poser des questions ouvertes). Tu peux aussi leur faire connaître tes propres champs d’intérêt. Note tes découvertes et faites ensemble une réflexion sur les expériences qu’elles et ils pourraient vivre en lien avec leurs centres d’intérêt.</p>`,
                  imageSrc: require("@/assets/fiches/apl1/AdobeStock_170759745.jpeg"),
                  imageAlt: "",
                },
                {
                  titre: "Créer des relations en peu de temps",
                  // milieu: "centre On y va",
                  milieu: this.LG("SA_nameAreaSection1"),
                  html: `<p>Aujourd’hui, comment peux-tu faire pour apprendre à connaître une famille qui se tient un peu plus en retrait?</p>`,
                  imageSrc: require("@/assets/fiches/apl1/AdobeStock_237102404.jpeg"),
                  imageAlt: "",
                },
              ],
            },
          ],
          infoSupp: [
            {
              titre: "Ressources additionnelles pour aller plus loin",
              linkBullets: [
                {
                  text: "La roue des émotions",
                  link: "https://lien.cforp.ca/31514",
                },
                {
                  text: "Penser, sentir, agir – Leçons tirées de la recherche sur la petite enfance",
                  link: "https://lien.cforp.ca/31515",
                },
                {
                  text: "Le pouvoir des relations positives entre l’adulte et l’enfant&nbsp;: la connexion est le facteur clé",
                  link: "https://lien.cforp.ca/31516",
                },
                {
                  text: "À quoi ressemble une relation sensible et attentive?",
                  link: "https://lien.cforp.ca/31517",
                },
              ],
            },
            {
              titre: "Mises en situation du jeu liées au sujet ciblé",
              linkBullets: [
                {
                  text: "L’expression sous toutes ses formes",
                  link: {
                    situation: 8,
                    page: "video",
                  },
                },
                {
                  text: "Un milieu stimulant et inclusif pour toutes et tous",
                  link: {
                    situation: 2,
                    page: "video",
                  },
                },
                {
                  text: "Nature et découverte",
                  link: {
                    situation: 4,
                    page: "video",
                  },
                },
              ],
            },
          ],
        },
        // allerPlusLoin 2
        {
          sujetCible: "",
          titre: "L’apprentissage par l’exploration, le jeu et l’enquête",
          sections: [
            {
              titre: "Résumé des concepts du sujet&nbsp;: définition/mise en contexte",
              html: `<p>L’exploration, le jeu et l’enquête sont essentiels au développement des enfants. Cela inclut le jeu extérieur, le jeu aventureux, le jeu salissant et toutes les occasions d’apprentissage basées sur l’exploration du monde qui nous entoure, la curiosité et les questionnements.</p>`,
              imageSrc: require("@/assets/fiches/apl2/AdobeStock_177065225.jpeg"),
              imageAlt: "",
            },
            {
              titre: "Questions de réflexion en lien avec le sujet ciblé",
              html: `<p>Qu’est-ce que le jeu pour toi?</p>`,
              imageSrc: require("@/assets/fiches/apl2/AdobeStock_240773885.jpeg"),
              imageAlt: "",
            },
            {
              titre: "Défis en lien avec le sujet ciblé",
              defis: [
                {
                  titre: "Observons les enfants pendant le jeu...",
                  // milieu: "centre éducatif",
                  milieu: this.LG("SA_nameAreaSection2"),
                  html: `<p>Aujourd’hui, en observant les enfants, relève cinq nouveaux bienfaits du jeu et communique le tout à tes collègues de travail.</p>`,
                  imageSrc: require("@/assets/fiches/apl2/AdobeStock_116148078.jpeg"),
                  imageAlt: "",
                },
                {
                  titre: "Aller plus loin avec les familles",
                  // milieu: "familial",
                  milieu: this.LG("SA_nameAreaSection4"),
                  html: `<p>Informe les familles des apprentissages que leurs enfants ont faits lors du jeu extérieur aujourd’hui. Fais-leur part des ressources sur les bienfaits du jeu extérieur et du jeu aventureux.</p>`,
                  imageSrc: require("@/assets/fiches/apl2/AdobeStock_460313941.jpeg"),
                  imageAlt: "",
                },
                {
                  titre: "Collaboration et engagement",
                  // milieu: "école",
                  milieu: this.LG("SA_nameAreaSection3"),
                  html: `<p>Aujourd’hui, en prêtant attention au jeu des enfants, quel serait un point de départ possible pour entreprendre un cycle d’enquête avec elles et eux?</p>`,
                  imageSrc: require("@/assets/fiches/apl2/AdobeStock_87994696.jpeg"),
                  imageAlt: "",
                },
                {
                  titre: "Matériaux et accompagnement",
                  // milieu: "centre On y va",
                  milieu: this.LG("SA_nameAreaSection1"),
                  html: `<p>Cette semaine, ajoute de nouveaux matériaux polyvalents dans l’espace de jeu et porte une attention à la façon dont les enfants et leurs familles les utilisent.</p>`,
                  imageSrc: require("@/assets/fiches/apl2/AdobeStock_345419205.jpeg"),
                  imageAlt: "",
                },
              ],
            },
          ],
          infoSupp: [
            {
              titre: "Ressources additionnelles pour aller plus loin",
              linkBullets: [
                {
                  text: "Libres et créatifs – YouTube",
                  link: "https://lien.cforp.ca/31518",
                },
                {
                  text: "L’apprentissage par le jeu",
                  link: "https://lien.cforp.ca/31519	",
                },
                {
                  text: "Coup d’œil sur le jeu extérieur – Se connecter à la nature!",
                  link: "https://lien.cforp.ca/31520",
                },
                {
                  text: "Le jeu libre des enfants – Énoncé de position – Mars 2019",
                  link: "https://lien.cforp.ca/31521",
                },
                {
                  text: "Comment apprend-on?",
                  link: "https://lien.cforp.ca/31522",
                },
              ],
            },
            {
              titre: "Mises en situation du jeu liées au sujet ciblé",
              linkBullets: [
                {
                  text: "On joue dehors!",
                  link: {
                    situation: 7,
                    page: "video",
                  },
                },
                {
                  text: "L’écoute visible.",
                  link: {
                    situation: 1,
                    page: "video",
                  },
                },
                {
                  text: "Prête ou prêt pour l’école, prête ou prêt pour la vie!",
                  link: {
                    situation: 10,
                    page: "video",
                  },
                },
              ],
            },
          ],
        },
        // allerPlusLoin 3
        {
          sujetCible: "",
          titre: "L’environnement comme troisième éducateur",
          sections: [
            {
              titre: "Résumé des concepts du sujet&nbsp;: définition/mise en contexte",
              html: `<p>L’environnement joue un rôle essentiel dans les apprentissages des enfants. Un environnement accueillant, inclusif et rempli de possibilités permet à l’enfant de se développer de façon harmonieuse et significative.</p>`,
              imageSrc: require("@/assets/fiches/apl3/AdobeStock_265143893.jpeg"),
              imageAlt: "",
            },
            {
              titre: "Questions de réflexion en lien avec le sujet ciblé",
              html: `<p>Comment notre environnement reflète-t-il nos valeurs et nos croyances en tant que personnel éducateur?</p>`,
              imageSrc: require("@/assets/fiches/apl3/AdobeStock_427679804.jpeg"),
              imageAlt: "",
            },
            {
              titre: "Défis en lien avec le sujet ciblé",
              defis: [
                {
                  titre: "Ce que l’environnement a à nous offrir",
                  // milieu: "centre éducatif",
                  milieu: this.LG("SA_nameAreaSection2"),
                  html: `<p>Au cours du jeu extérieur, prends conscience de ce qui attire ton attention&nbsp;: par exemple, est-ce que tu observes plutôt les dangers, les curiosités des enfants, leur façon de jouer? Essaie quelque chose de nouveau.</p>`,
                  imageSrc: require("@/assets/fiches/apl3/AdobeStock_324185211.jpeg"),
                  imageAlt: "",
                },
                {
                  titre: "Des matériaux pour toutes les curiosités",
                  // milieu: "familial",
                  milieu: this.LG("SA_nameAreaSection4"),
                  html: `<p>Aujourd’hui, expérimente les matériaux que tu n’utilises pas souvent et deviens coapprenante ou coapprenant avec les enfants.</p>`,
                  imageSrc: require("@/assets/fiches/apl3/AdobeStock_270290600.jpeg"),
                  imageAlt: "",
                },
                {
                  titre: "Un environnement qui nous ressemble",
                  // milieu: "école",
                  milieu: this.LG("SA_nameAreaSection3"),
                  html: `<p>Aujourd’hui, encourage les enfants qui t’entourent à aménager leur propre environnement.</p>`,
                  imageSrc: require("@/assets/fiches/apl3/AdobeStock_203008652.jpeg"),
                  imageAlt: "",
                },
                {
                  titre: "Aménager pour mieux connecter",
                  // milieu: "centre On y va",
                  milieu: this.LG("SA_nameAreaSection1"),
                  html: `<p>Aujourd’hui, demande aux familles de contribuer en apportant du matériel (p. ex., photos, musique, décorations, vêtements, objets du quotidien) pour aménager la salle.</p>`,
                  imageSrc: require("@/assets/fiches/apl3/AdobeStock_449007164.jpeg"),
                  imageAlt: "",
                },
              ],
            },
          ],
          infoSupp: [
            {
              titre: "Ressources additionnelles pour aller plus loin",
              linkBullets: [
                {
                  text: "Comment apprend-on?",
                  link: "https://lien.cforp.ca/31523",
                },
                {
                  text: "L’environnement en tant qu’éducateur",
                  link: "https://lien.cforp.ca/31524",
                },
                {
                  text: "Reggio Emilia Approach 1 – YouTube",
                  link: "https://lien.cforp.ca/31525",
                },
                {
                  text: "Reggio Emilia Loose Parts Provocation – YouTube",
                  link: "https://lien.cforp.ca/31526",
                },
              ],
            },
            {
              titre: "Mises en situation du jeu liées au sujet ciblé",
              linkBullets: [
                {
                  text: "Explorons le jeu aventureux!",
                  link: {
                    situation: 11,
                    page: "video",
                  },
                },
                {
                  text: "Un environnement riche en expériences d’apprentissage!",
                  link: {
                    situation: 5,
                    page: "video",
                  },
                },
                {
                  text: "Cultiver de saines habitudes de vie",
                  link: {
                    situation: 6,
                    page: "video",
                  },
                },
              ],
            },
          ],
        },
        // allerPlusLoin 4
        {
          sujetCible: "",
          titre: "L’engagement familial",
          sections: [
            {
              titre: "Résumé des concepts du sujet&nbsp;: définition/mise en contexte",
              html: `<p>L’engagement familial est un des maillons du développement de l’enfant et doit faire partie intégrante de nos pratiques en petite enfance. En effet, la famille est le premier modèle éducatif des enfants et son implication dans les programmes peut apporter de nombreux bienfaits. </p>`,
              imageSrc: require("@/assets/fiches/apl4/AdobeStock_277586010.jpeg"),
              imageAlt: "",
            },
            {
              titre: "Questions de réflexion en lien avec le sujet ciblé",
              html: `<p>Comment pouvons-nous favoriser l’engagement familial tout en respectant le rythme et le degré d’aisance de chaque famille?</p>`,
              imageSrc: require("@/assets/fiches/apl4/AdobeStock_33145817.jpeg"),
              imageAlt: "",
            },
            {
              titre: "Défis en lien avec le sujet ciblé",
              defis: [
                {
                  titre: "Apprendre à se connaître",
                  // milieu: "centre éducatif",
                  milieu: this.LG("SA_nameAreaSection2"),
                  html: `<p>Renseigne-toi sur les champs d’intérêt ou les traditions des familles et invite-les à venir les communiquer aux enfants.</p>`,
                  imageSrc: require("@/assets/fiches/apl4/AdobeStock_301790714.jpeg"),
                  imageAlt: "",
                },
                {
                  titre: "Réseautons!",
                  // milieu: "familial",
                  milieu: this.LG("SA_nameAreaSection4"),
                  html: `<p>Ce mois-ci, trouve une façon de permettre aux familles d’échanger et de créer des liens entre elles. Que ce soit par une activité spéciale, un repas, une invitation à un événement communautaire, un groupe de discussion privé sur les réseaux sociaux, une mise en commun de recettes familiales ou autre. Fais preuve d’initiative pour favoriser le sentiment d’appartenance des familles à la communauté. </p>`,
                  imageSrc: require("@/assets/fiches/apl4/AdobeStock_195050014.jpeg"),
                  imageAlt: "",
                },
                {
                  titre: "Impliquons-nous à notre façon...",
                  // milieu: "école",
                  milieu: this.LG("SA_nameAreaSection3"),
                  html: `<p>Cette semaine, dresse l’inventaire des professions et des champs d’intérêt des familles, qui pourra être une source d’inspiration pour des projets. Par exemple, si un parent est plombier, il aurait sûrement du matériel à donner, ou si une grand-maman aime le tricot, elle pourrait venir en faire avec les enfants. </p>`,
                  imageSrc: require("@/assets/fiches/apl4/AdobeStock_76085076.jpeg"),
                  imageAlt: "",
                },
                {
                  titre: "Reconnaissons les bienfaits de l’enquête",
                  // milieu: "centre On y va",
                  milieu: this.LG("SA_nameAreaSection1"),
                  html: `<p>Développe une ressource au sujet du cycle de l’enquête, que tu pourras transmettre aux familles. Profites-en pour utiliser des photos de leurs enfants en action. </p>`,
                  imageSrc: require("@/assets/fiches/apl4/AdobeStock_415766683.jpeg"),
                  imageAlt: "",
                },
              ],
            },
          ],
          infoSupp: [
            {
              titre: "Ressources additionnelles pour aller plus loin",
              linkBullets: [
                {
                  text: "Communiquer et collaborer avec les familles",
                  link: "https://lien.cforp.ca/31527",
                },
                {
                  text: "Comment apprend-on?",
                  link: "https://lien.cforp.ca/31528",
                },
                {
                  text: "Autoformation portant sur le bien-être",
                  link: "https://lien.cforp.ca/31529",
                },
                {
                  text: "Autoformation – L’apprentissage par l’exploration, le jeu et l’enquête",
                  link: "https://lien.cforp.ca/31530",
                },
              ],
            },
            {
              titre: "Mises en situation du jeu liées au sujet ciblé",
              linkBullets: [
                {
                  text: "L’accueil des familles",
                  link: {
                    situation: 0,
                    page: "video",
                  },
                },
                {
                  text: "Ici, je suis chez moi",
                  link: {
                    situation: 3,
                    page: "video",
                  },
                },
                {
                  text: "À la découverte de ma communauté…",
                  link: {
                    situation: 9,
                    page: "video",
                  },
                },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
    getPageLink(link) {
      return `/${this.getMatchedAreaName(link.situation)}/${this.getSituationNameFromSituationIndex(link.situation)}/${link.page}`;
    },
  },

  created() {
    if (this.allerPlusLoinId != undefined) {
      this.currentFiche = this.allerPlusLoin[this.allerPlusLoinId];
    }
  },
};
</script>

<style scoped>
span + span {
  margin-left: 0px;
}
h1.title {
  text-align: center;
  margin-top: 5px;
  margin-bottom: 25px;
  font-family: "Poppins";
  color: #333;
}
h2 {
  font-size: 1.35rem !important;
  color: #000;
}
h3 {
  font-size: 1.35rem !important;
  color: #154f68 !important;
}

.section-container {
  position: relative;
  margin-top: 24px;
  /* width: 95%; */
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.section-area {
  border-radius: 57px;
  border: 10px solid #ffffff;
  background-color: #eaeaea;
  font-family: "Poppins";
  /* color: #374a66 !important; */
  color: #1f2d4c !important;
  font-size: 17px;
  padding: 20px 25px 25px 25px;

  margin-left: auto;
}

.section-num {
  position: absolute;
  top: 5px;
  left: 0px;

  font-size: 1.6rem;
  font-weight: 600;

  padding-left: 13px;
  padding-right: 13px;
  padding-bottom: 3px;

  background-color: #154f68;
  color: #fff;
  border: solid 7px #fff;
  border-radius: 50%;

  font-variant-numeric: tabular-nums;
}
.section-area img.corner-cutted {
  border-radius: 15px;
}
.section-area ul {
  list-style: none; /* Remove default bullets */
}

.section-area ul li::before {
  content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #5aa9af; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-left: -1em; /* Also needed for space (tweak if needed) */
}
@media reader, speech, aural {
  .section-area ul li::before {
    display: none !important;
    visibility: hidden !important;
  }
}
.attachement {
  background-color: #fff;
  margin-left: -26px;
  margin-right: -26px;
  padding-left: 11px;
  padding-right: 11px;

  padding-bottom: 30px;

  margin-bottom: -38px;

  border-end-end-radius: 53px;
  border-end-start-radius: 53px;
}
.attachement h3 {
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
.video-section {
  padding-top: 10px;
  padding-bottom: 35px;
}
.defi-wrapper {
  margin-top: 10px;
}
.defi-box {
  padding-top: 15px;
  padding-bottom: 15px;

  margin-left: -26px;
  margin-right: -26px;

  padding-left: 11px;
  padding-right: 11px;
}
.defi-box:nth-child(odd) {
  background-color: #fff;
}
.infoSuppTable {
  margin-top: 15px;
  width: 100%;
}
.infoSuppTable th {
  background-color: #154f68;
  padding: 20px;
  text-align: center;
  width: 50%;
}
.infoSuppTable th span {
  color: #fff;
  font-weight: 500;
  max-width: 250px;
  display: inline-block;
}
.infoSuppTable td:nth-child(1) {
  border-right: solid 2px #154f68;
}
.infoSuppTable td {
  padding-top: 12px;
  padding-right: 20px;
  vertical-align: top;
}
.infoSuppTable li {
  padding-top: 7px;
}

.infoSuppTable a {
  color: #1f2d4c !important;
  text-decoration: underline !important;
}

.infoSuppTable h3 {
  font-size: 1rem !important;
  color: #fff !important;
  background-color: #154f68;
  padding: 15px;
  font-weight: 500;
}
</style>
